import { useT } from "../i18n/hooks.ts";

// Also hidden while the Results Dashboard panel is open: a multi-selection
// made with that panel open is being built to chart/tabulate, not to
// bulk-edit or bulk-delete.
export function MultiSelectBar({
  count,
  canGroupEdit,
  onGroupEdit,
  onDelete,
  onClose,
}: {
  count: number;
  canGroupEdit: boolean;
  onGroupEdit: () => void;
  onDelete: () => void;
  onClose: () => void;
}) {
  const t = useT();
  return (
    <div className="results-animation-bar">
      <span className="results-animation-label">{t("multiSelect.count", { count })}</span>
      <button className="button" onClick={onGroupEdit} disabled={!canGroupEdit}>
        {t("multiSelect.groupEdit")}
      </button>
      <button className="button button-danger" onClick={onDelete}>
        {t("multiSelect.delete")}
      </button>
      <button className="button" onClick={onClose}>
        {t("common.close")}
      </button>
    </div>
  );
}
